import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { tablet768, desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import { paddingBuilder, themeSpace } from 'styles/themeUtils';

const SectionContent = styled(Typography)`
  margin-bottom: ${themeSpace(2.5)};

  ${paddingBuilder.right(1)}

  ${tablet768`
    ${paddingBuilder.all(0)}
  `}

  ${desktop1440`
    ${paddingBuilder.right(7.5)}
  `}
`;

SectionContent.displayName = 'SectionContent';

export default SectionContent;
